<script setup>
import { onMounted, computed, watch } from "vue"
import { RouterView, useRoute } from "vue-router"
import { useHead } from '@vueuse/head'
import { useI18n } from 'vue-i18n'

const route = useRoute()
const { locale } = useI18n()
const BASE_URL = 'https://stageisthestreet.com'

// hreflang global: indica a Google que cada página está disponible en 4 idiomas
const hreflangLinks = computed(() => {
  const path = route.fullPath
  const url = `${BASE_URL}${path}`
  return [
    { rel: 'alternate', hreflang: 'es', href: url },
    { rel: 'alternate', hreflang: 'en', href: url },
    { rel: 'alternate', hreflang: 'eu', href: url },
    { rel: 'alternate', hreflang: 'ca', href: url },
    { rel: 'alternate', hreflang: 'x-default', href: url },
  ]
})

useHead({
  link: hreflangLinks,
  script: [
    {
      type: 'application/ld+json',
      key: 'schema-organization',
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Stage is the Street",
        
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Bizkaia",
          "addressCountry": "ES"
        },
        "url": "https://stageisthestreet.com",
        "description": "Plataforma de descubrimiento de artistas callejeros y eventos urbanos en vivo",
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer support"
        },
        "sameAs": ["https://www.instagram.com/sits25", "https://twitter.com/sits25"]
      })
    }
  ]
})

// Actualizar lang del HTML dinámicamente según el idioma seleccionado
watch(
  () => locale.value,
  (newLocale) => {
    document.documentElement.lang = newLocale
  },
  { immediate: true }
)

onMounted(() => {
  // Script para anuncios Google Ads si el usuario dio consentimiento
  /*if (localStorage.getItem("cookieConsent") === "all") {
    const adsScript = document.createElement("script")
    adsScript.async = true
    adsScript.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8335154798852284"
    adsScript.setAttribute("crossorigin", "anonymous")
    document.head.appendChild(adsScript)
  }*/
})
</script>

<template>
  <RouterView />
  <!--<CookieConsent />-->
</template>
<style>
.page-content {

  min-height: calc(100vh - 78px); /* Ajusta según la altura del footer */
}</style>